export default __webpack_public_path__ + "static/media/4.da9d40e2.jpg";